<template>
	<div class="project-container">
		<div class="project-content">
			<div class="tab-container">
				<div class="cjt-tabs">
					<div class="cjt-tabs__header">
						<div class="cjt-tabs__nav-wrap">
							<div
								v-for="(tab, index) in maintenanceTabs"
								:key="index"
								class="cjt-tabs__item"
								:class="{ active: activeTabIndex === index }"
								@click="changeMaintenanceTab(index)"
							>
								<span class="cjt-tabs__item-text">{{ tab.name }}</span>
								<span v-if="tab.isHot" class="tag-member-mini tag-member--vip">HOT</span>
							</div>

							<!-- <div class="cjt-tabs-more">
									<router-link to="#">
										更多
										<i class="el-icon-arrow-right"></i>
									</router-link>
								</div> -->
						</div>
					</div>
					<div class="cjt-tabs__container">
						<transition name="fade-transform" mode="out-in">
							<div :key="activeTabIndex" class="cjt-tabs__content">
								<!-- 临期提醒内容 -->
								<div v-if="activeTabIndex === 0" class="qualificationQuery-search">
									<el-form ref="normalSearchForm" :model="normalSearchForm" label-width="150px" class="searchForm">
										<el-form-item label="项目名称" prop="projectName">
											<el-input v-model="normalSearchForm.projectName" placeholder="请输入项目名称"></el-input>
										</el-form-item>
										<el-form-item label="项目编码" prop="projectCode">
											<el-input v-model="normalSearchForm.projectCode" placeholder="请输入项目编码"></el-input>
										</el-form-item>
									</el-form>
									<div class="search-button-box">
										<el-button class="search" @click="handleSearch">查询</el-button>
										<el-button class="reset" @click="handleReset">重置</el-button>
									</div>
								</div>
								<div v-if="activeTabIndex === 1" class="qualificationQuery-search">
									<el-form ref="searchForm" :model="searchForm" label-width="150px" class="searchForm">
										<el-form-item label="项目类别" prop="projectType" class="category-box">
											<el-select v-model="searchForm.projectType" placeholder="请选择项目类别">
												<el-option
													v-for="item in projectTypeDict"
													:key="item.dictCode"
													:label="item.dictValue"
													:value="item.dictCode"
												></el-option>
											</el-select>
										</el-form-item>
										<el-form-item label="项目属地" prop="countyCode" class="people-box">
											<el-cascader
												ref="xmAddress"
												v-model="addressList"
												:options="divisionHbDictList"
												:props="cityDictProps"
												style="width: 100%"
												@change="xmAddressAfterChange"
											></el-cascader>
										</el-form-item>
										<el-form-item label="项目名称" prop="projectName">
											<el-input v-model="searchForm.projectName" placeholder="请输入项目名称"></el-input>
										</el-form-item>
										<el-form-item label="建设单位名称" prop="constructionUnit">
											<el-input v-model="searchForm.constructionUnit" placeholder="请输入建设单位名称"></el-input>
										</el-form-item>
										<el-form-item label="总投资" prop="moneyAll" class="money-box">
											<div class="limit-box-out">
												<el-radio-group v-model="moneyAll">
													<el-radio-button v-for="item in cities" :key="item.value" :label="item.value">
														{{ item.name }}
													</el-radio-button>
												</el-radio-group>
												<div class="limit-box-inner">
													<div class="limit-box">
														<el-input
															v-model="searchForm.minMoney"
															placeholder="最低金额"
															:disabled="moneyAll === '' ? false : true"
														></el-input>
														<span>万</span>
													</div>
													<span class="limit-fg">--</span>
													<div class="limit-box">
														<el-input
															v-model="searchForm.maxMoney"
															placeholder="最高金额"
															:disabled="moneyAll === '' ? false : true"
														></el-input>
														<span>万</span>
													</div>
												</div>
											</div>
										</el-form-item>
										<el-form-item label="建设性质" prop="projectProperty">
											<el-select v-model="searchForm.projectProperty" placeholder="请选择建设性质">
												<el-option
													v-for="item in constructionTypeDict"
													:key="item.dictCode"
													:label="item.dictValue"
													:value="item.dictCode"
												></el-option>
											</el-select>
										</el-form-item>
										<el-form-item label="报建日期" prop="validityTimeEnd">
											<el-date-picker
												v-model="validityTimeEnd"
												type="daterange"
												range-separator="至"
												start-placeholder="开始日期"
												end-placeholder="结束日期"
												value-format="yyyy-MM-dd"
											></el-date-picker>
										</el-form-item>
										<el-form-item label="立项级别" prop="projectLevel">
											<el-select v-model="searchForm.projectLevel" placeholder="请选择立项级别">
												<el-option
													v-for="item in projectLevelDict"
													:key="item.dictCode"
													:label="item.dictValue"
													:value="item.dictCode"
												></el-option>
											</el-select>
										</el-form-item>
									</el-form>
									<div class="search-button-box">
										<el-button class="search" @click="handleSearch">查询</el-button>
										<el-button class="reset" @click="handleReset">重置</el-button>
									</div>
								</div>
							</div>
						</transition>
					</div>
					<!-- 热门查询区域--start -->
					<!-- <div class="hot-query-container">
						<div class="hot-query-content">
							<div class="hot-query-list">
								<h3 class="list-title">热门查询</h3>
								<div class="query-items">
									<div class="query-item">
										<div class="icon icon-czz"></div>
										<div class="item-content">
											<h4>查资质</h4>
											<p>查询资质，降低废证风险</p>
										</div>
										<i class="el-icon-arrow-right"></i>
									</div>
									<div class="query-item">
										<div class="icon icon-cfx"></div>
										<div class="item-content">
											<h4>查风险</h4>
											<p>查询资质，降低废证风险</p>
										</div>
										<i class="el-icon-arrow-right"></i>
									</div>
									<div class="query-item">
										<div class="icon icon-cyj"></div>
										<div class="item-content">
											<h4>查业绩</h4>
											<p>查询资质，降低废证风险</p>
										</div>
										<i class="el-icon-arrow-right"></i>
									</div>
									<div class="query-item">
										<div class="icon icon-hyxy"></div>
										<div class="item-content">
											<h4>查行业信用</h4>
											<p>查询资质，降低废证风险</p>
										</div>
										<i class="el-icon-arrow-right"></i>
									</div>
									<div class="query-item">
										<div class="icon icon-cll"></div>
										<div class="item-content">
											<h4>查履历</h4>
											<p>查询资质，降低废证风险</p>
										</div>
										<i class="el-icon-arrow-right"></i>
									</div>
									<div class="query-item">
										<div class="icon icon-zzsy"></div>
										<div class="item-content">
											<h4>资质溯源</h4>
											<p>查询资质，降低废证风险</p>
										</div>
										<i class="el-icon-arrow-right"></i>
									</div>
								</div>
							</div>
						</div>
					</div> -->
					<!-- 热门查询区域--end -->

					<div v-loading="loading" class="maintenance-list">
						<!-- 列表项 -->
						<template v-if="projectList.length > 0">
							<!-- 展示当前有多少条数据 -->
							<div class="notification-title">
								<span class="title-text">
									共有
									<span class="data-count">{{ pageOptions.total }}</span>
									条数据
								</span>
							</div>
							<div v-for="(item, index) in projectList" :key="index" class="notification-item">
								<div class="certificate-info">
									<div class="certificate-name">
										<div>
											{{ item.projectName }}
										</div>
									</div>
									<div class="certificate-detail">
										<div class="detail-item">
											<label>项目编码：</label>
											<span class="detail-content">
												{{ item.projectCode ? item.projectCode : '--' }}
											</span>
										</div>
										<div class="detail-item">
											<label>所属地区：</label>
											<span class="detail-content">{{ item.addressName ? item.addressName : '--' }}</span>
										</div>
										<div class="detail-item">
											<label>项目地址：</label>
											<span class="detail-content">{{ item.address ? item.address : '--' }}</span>
										</div>
									</div>
								</div>
								<div class="certificate-status">
									<span class="collect" @click="handleToProjectDetail(item)">
										<svg-icon icon-class="view" class="icon" />
										查看
									</span>
									<span class="collect" @click="handleIsCollect(item.id, item.isCollect)">
										<svg-icon v-if="!item.isCollect" icon-class="collect" class="icon" />
										<svg-icon v-else icon-class="collected" class="icon collected" />
										{{ item.isCollect ? '已收藏' : '收藏' }}
									</span>
								</div>
							</div>
						</template>
						<!-- 数据为空 -->
						<empty-content v-else></empty-content>
					</div>
					<!-- 分页器 -->
					<jr-pagination
						v-if="pageOptions.total > pageOptions.limit"
						:limit="pageOptions.limit"
						:page.sync="pageOptions.page"
						:total="pageOptions.total"
						layout="prev, pager, next"
						prev-text="上一页"
						next-text="下一页"
						@change="handlePaginationChange"
					></jr-pagination>
				</div>
			</div>
		</div>
		<!-- 购买会员弹窗 -->
		<jr-dialog :visible.sync="payVisible" width="840px" :show-btn="false" @close="handleCancel">
			<template slot="title">
				<!-- 自定义弹窗标题 -->
				<h4 class="model-title">
					<span>购买会员</span>
				</h4>
			</template>
			<template slot="content">
				<payment-dialog @payOrderSuccess="handlePayOrderSuccessCallback"></payment-dialog>
			</template>
		</jr-dialog>

		<!-- 登录弹窗 -->
		<jr-dialog
			:visible.sync="loginVisible"
			width="560px"
			:custom-class="'loginDialog'"
			:show-btn="false"
			@loginDone="loginVisible = false"
		>
			<template slot="content">
				<non-login></non-login>
			</template>
		</jr-dialog>
	</div>
</template>

<script>
	import JrDialog from '@/components/Dialog'
	import PaymentDialog from '@/views/memberBenefits/paymentDialog.vue'
	import NonLogin from '@/components/NonLogin'
	import { mapState, mapGetters } from 'vuex'
	import JrPagination from '@/components/Pagination'
	import { getProjectList, pageTabAdvancedQuery } from '@/api/qualificationQuery/project'
	import { mapDictionaries } from '@/store/dictionary-helper'
	import { COLLECT_TYPE_STATE } from '@/enum/index'
	import { saveUserCollect, removeUserCollect } from '@/api/userCenter/index'
	import { getDictFlattenList } from '@/api/dictionary/index'
	// import { ENUM_MEMBER_BENEFIT } from '@/enum/memberBenefitRecord'
	import memberBenefitCheckerMixins from '@/mixins/memberBenefitCheckerMixins'

	export default {
		name: 'SearchProject',
		components: {
			JrPagination,
			JrDialog,
			PaymentDialog,
			NonLogin
		},
		// 使用会员权益前置校验mixins
		mixins: [memberBenefitCheckerMixins],
		props: {},
		data() {
			return {
				// 购买会员弹窗
				payVisible: false,
				// 登录弹窗
				loginVisible: false,
				// 查项目Tab数据
				activeTabIndex: 0,
				maintenanceTabs: [
					{ name: '普通查询', isHot: false },
					{ name: '高级查询', isHot: true }
				],
				normalSearchForm: {
					projectName: '',
					projectCode: ''
				},
				// 报建日期
				validityTimeEnd: [],
				// 总投资
				moneyAll: '',
				searchForm: {
					projectName: '', // 项目名称
					projectCode: '', // 项目编码
					constructionUnit: '', // 建设单位
					projectType: '', // 项目类别
					provinceCode: '', // 省
					cityCode: '', // 市
					countyCode: '', // 区县
					projectProperty: '', // 项目性质
					projectLevel: '', // 项目等级
					constructionTimeStart: '', // 开始时间
					constructionTimeEnd: '', // 结束时间
					minMoney: '', // 投资金额（起）
					maxMoney: '' // 投资金额（止）
				},
				// 省级区划
				addressList: [],
				divisionHbDictList: [],
				cityDictProps: {
					label: 'dictValue',
					value: 'dictCode',
					children: 'children',
					isLeaf: 'isLeaf'
				},
				cities: [
					{
						name: '不限',
						value: ''
					},
					{
						name: '100万以上',
						value: '100'
					},
					{
						name: '500万以上',
						value: '500'
					},
					{
						name: '1000万以上',
						value: '1000'
					},
					{
						name: '5000万以上',
						value: '5000'
					}
				],
				// 项目
				projectList: [],
				pageOptions: {
					currentPage: 1,
					limit: 10,
					total: 0
				},

				loading: false,
				isAdvancedSearch: false //是否高级查询
			}
		},
		computed: {
			...mapGetters(['vipLevel', 'isNormalVip', 'isVip', 'isSVip']),
			...mapState({
				token: state => state.user.token
			}),
			// 使用自定义的映射函数
			...mapDictionaries('dictionary', ['addressDict', 'projectLevelDict', 'constructionTypeDict', 'projectTypeDict'])
		},
		watch: {},
		created() {},
		async mounted() {
			if (this.$route.query && this.$route.query.value) {
				if (this.token) {
					if (this.$route.query.isHight === 'true') {
						this.searchForm.projectName = this.$route.query.value
						this.activeTabIndex = 1
					} else {
						this.normalSearchForm.projectName = this.$route.query.value
					}
				} else {
					this.loginVisible = true
				}
			}
			await this.$store.dispatch('dictionary/getAddressDictList')
			await this.handleGetHbDivision()

			// 判断当前没有登录的情况下,调取新的接口，并只查询10条数据
			if (!this.token) {
				await this.initNoLoginProjectList()
			} else {
				if (this.$route.query.isHight === 'true') {
					await this.initAdvancedProjectList()
				} else {
					await this.initProjectList()
				}
			}
		},
		methods: {
			// 判断用户是否登录
			async handleSearch() {
				if (!this.token) {
					this.loginVisible = true
					return
				}
				if (this.activeTabIndex === 1) {
					// 会员功能取消屏蔽--start
					// const isValid = await this.validateMemberBenefit(ENUM_MEMBER_BENEFIT.GJCX_FILER)
					// if (!isValid) {
					// 	this.payVisible = true
					// 	return
					// }
					// 会员功能取消屏蔽--end
				}
				if (this.activeTabIndex === 0) {
					this.initProjectList()
				} else {
					this.initAdvancedProjectList()
				}
			},
			// 初始化列表
			initProjectList() {
				this.loading = true
				const params = {
					page: this.pageOptions.currentPage,
					limit: this.pageOptions.limit,
					projectName: this.normalSearchForm.projectName,
					projectCode: this.normalSearchForm.projectCode
				}

				getProjectList(params)
					.then(res => {
						res.data.records = res.data.records.map(item => ({
							...item,
							addressName: [
								this.addressDict.find(e => item.cityCode === e.dictCode)?.dictValue || '',
								this.addressDict.find(e => item.countyCode === e.dictCode)?.dictValue || ''
							].join('')
						}))
						this.projectList = res.data.records
						this.pageOptions.total = res.data.total
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			},
			// 初始化列表(未登录情况下，只查询10条数据)
			initNoLoginProjectList() {
				this.loading = true
				const params = {
					page: 1,
					limit: 10
				}

				getProjectList(params)
					.then(res => {
						res.data.records = res.data.records.map(item => ({
							...item,
							addressName: [
								this.addressDict.find(e => item.cityCode === e.dictCode)?.dictValue || '',
								this.addressDict.find(e => item.countyCode === e.dictCode)?.dictValue || ''
							].join('')
						}))
						this.projectList = res.data.records
						this.pageOptions.total = res.data.total
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			},
			initAdvancedProjectList() {
				if (this.validityTimeEnd.length > 0) {
					this.searchForm.constructionTimeStart = this.validityTimeEnd[0]
					this.searchForm.constructionTimeEnd = this.validityTimeEnd[1]
				}
				if (this.moneyAll) {
					this.searchForm.minMoney = this.moneyAll
					this.searchForm.maxMoney = null
				}
				const params = {
					page: this.pageOptions.currentPage,
					limit: this.pageOptions.limit,
					...this.searchForm
				}
				pageTabAdvancedQuery(params)
					.then(res => {
						res.data.records = res.data.records.map(item => ({
							...item,
							addressName: [
								this.addressDict.find(e => item.cityCode === e.dictCode)?.dictValue || '',
								this.addressDict.find(e => item.countyCode === e.dictCode)?.dictValue || ''
							].join('')
						}))
						this.projectList = res.data.records
						this.pageOptions.total = res.data.total
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			},
			// 查询湖北省行政区划
			handleGetHbDivision() {
				const params = {
					parentId: '3ab7d41d88bd458da622fb21e84ea5b3',
					level: '3'
				}
				getDictFlattenList(params).then(response => {
					const { data } = response
					if (!data || data.length === 0) {
						this.divisionHbDictList = []
						return
					}
					// 创建id到节点的映射
					const nodeMap = {}
					const tree = []

					// 第一遍遍历：创建所有节点的映射
					data.forEach(item => {
						nodeMap[item.id] = {
							...item,
							children: []
						}
					})

					// 第二遍遍历：构建树形结构
					data.forEach(item => {
						const node = nodeMap[item.id]
						if (item.pId && nodeMap[item.pId]) {
							nodeMap[item.pId].children.push(node)
						} else {
							tree.push(node)
						}
					})

					// 遍历三级节点设置isLeaf为true
					tree.forEach(province => {
						if (province.children) {
							province.children.forEach(city => {
								if (city.children) {
									city.children.forEach(county => {
										county.children = null
									})
								}
							})
						}
					})

					this.divisionHbDictList = tree
					// console.log(this.divisionHbDictList)
				})
			},
			// 住所变更后切换
			xmAddressAfterChange(val) {
				this.searchForm.provinceCode = val[0]
				this.searchForm.cityCode = val[1]
				this.searchForm.countyCode = val[2]
			},
			// 切换Tab
			changeMaintenanceTab(index) {
				this.activeTabIndex = index
			},
			// 分页
			handlePaginationChange(pager) {
				if (!this.token) {
					this.pageOptions.page = 1
					this.loginVisible = true
					return
				}
				const { page, limit } = pager
				this.pageOptions.currentPage = page
				this.pageOptions.limit = limit
				if (this.activeTabIndex === 1) {
					this.initAdvancedProjectList()
				} else {
					this.initProjectList()
				}
			},
			// 跳转详情
			handleToProjectDetail(projectInfo) {
				if (!this.token) {
					this.loginVisible = true
					return
				} else {
					const routeData = this.$router.resolve({
						path: '/qualification-query/projectDetail',
						query: {
							id: projectInfo.id
						}
					})
					window.open(routeData.href, '_blank')
				}
			},
			handleIsCollect(id, flag) {
				if (!this.token) {
					this.loginVisible = true
					return
				}
				if (!this.isVip && !this.isSVip) {
					this.$message.error('暂不是高级会员，请先购买会员')
					return
				}
				if (flag) {
					this.handleRemoveCollect(id)
				} else {
					this.handleCollect(id)
				}
			},
			handleCollect(id) {
				const params = {
					collectIds: [id],
					collectType: COLLECT_TYPE_STATE.PROJECT
				}
				saveUserCollect(params).then(res => {
					this.$message.success('收藏成功')
					if (this.activeTabIndex === 1) {
						this.initAdvancedProjectList()
					} else {
						this.initProjectList()
					}
				})
			},
			handleRemoveCollect(id) {
				const params = {
					collectIds: [id],
					collectType: COLLECT_TYPE_STATE.PROJECT
				}
				removeUserCollect(params).then(res => {
					this.$message.success('已取消收藏')
					if (this.activeTabIndex === 1) {
						this.initAdvancedProjectList()
					} else {
						this.initProjectList()
					}
				})
			},
			// 重置
			handleReset() {
				if (!this.token) {
					this.loginVisible = true
					return
				}
				if (this.activeTabIndex === 1) {
					this.moneyAll = ''
					this.validityTimeEnd = []
					this.searchForm = {
						projectName: '', // 项目名称
						projectCode: '', // 项目编码
						constructionUnit: '', // 建设单位
						projectType: '', // 项目类别
						provinceCode: '', // 省
						cityCode: '', // 市
						countyCode: '', // 区县
						projectProperty: '', // 项目性质
						projectLevel: '', // 项目等级
						constructionTimeStart: '', // 开始时间
						constructionTimeEnd: '', // 结束时间
						minMoney: '', // 投资金额（起）
						maxMoney: '' // 投资金额（止）
					}
				} else {
					this.normalSearchForm = {
						projectName: '',
						projectCode: ''
					}
				}

				if (this.activeTabIndex === 1) {
					this.initAdvancedProjectList()
				} else {
					this.initProjectList()
				}
			},
			// 订单创建成功回调
			handlePayOrderSuccessCallback() {
				this.payVisible = false
				this.$router.push({
					path: '/user/market/order'
				})
			},
			handleCancel() {
				this.payVisible = false
			}
		}
	}
</script>

<style lang="scss" scoped>
	.project-container {
		background-color: #eff6f9;
		.project-content {
			padding-top: 31px;
			.cjt-tabs__header {
				width: $main-page-width;
				margin: 0 auto;
				border-bottom: none;
				margin-bottom: 14px;
				.cjt-tabs__item {
					padding-bottom: 14px;
					position: relative;
					.cjt-tabs__item-text {
						font-size: 20px;
						color: #333333;
					}
					.tag-member-mini {
						height: 18px;
						line-height: 18px;
						position: absolute;
						right: -51px;
						top: -10px;
						padding: 0px 7px;
					}
				}
				.active {
					.cjt-tabs__item-text {
						color: #2671cb;
					}
					&::after {
						width: 40px;
					}
				}
			}
			.cjt-tabs__container {
				min-height: auto;
			}
			.hot-query-container {
				height: auto;
				background: none;
				.list-title {
					color: #333;
				}
				.hot-query-content {
					padding-top: 30px;
					background: #fff;
					padding-bottom: 30px;
					.query-items {
						padding-left: 20px;
						padding-right: 10px;
					}
					.list-title {
						padding-left: 20px;
					}
				}
			}
			.qualificationQuery-search {
				width: $main-page-width;
				margin: 0 auto;
				padding: 20px;
			}
			.maintenance-list {
				width: $main-page-width;
				margin: 0 auto;
				padding: 20px;
				background-color: #ffffff;
				// box-shadow: 2px 7px 21px 0px rgba(57, 127, 212, 0.17);
				border-radius: 6px;
				border-top-left-radius: 0px;
				border-top-right-radius: 0px;
				margin-top: 20px;
				.notification-title {
					background-color: #f5f7fa;
					// border-bottom: 1px solid #ebeef5;
					padding: 12px 20px;
					margin-bottom: 8px;
					border-radius: 4px 4px 0 0;

					.title-text {
						color: #606266;
						font-size: 16px;
						font-weight: 500;

						.data-count {
							color: #409eff;
							font-size: 18px;
							font-weight: 600;
							margin: 0 4px;
						}
					}
				}
				.notification-item {
					justify-content: space-between;
				}
				.certificate-info {
					flex: 0 0 1000px;
					.certificate-name {
						span {
							margin-left: 10px;
						}
					}
					.detail-item {
						label {
							flex: none;
						}
						.detail-content {
							padding-right: 0px;
						}
					}

					.detail-item:nth-child(1) {
						flex: 0 0 269px;
					}
					.detail-item:nth-child(2) {
						flex: 0 0 381px;
					}
				}
				.certificate-status {
					flex-direction: row;
					span {
						width: 100px;
						height: 36px;
						background-color: #ffffff;
						border-radius: 18px;
						border: solid 1px #236fca;
						text-align: center;
						color: #236fca;
						font-size: 16px;
						margin-left: 10px;
						cursor: pointer;
						display: flex;
						justify-content: center;
						align-items: center;
						&:hover {
							color: #fff;
							background-color: #236fca;
							.icon {
								color: #fff !important;
							}
						}
					}
					.collect {
						.icon {
							margin-right: 5px;
							font-size: 18px;
						}
						.collected {
							color: #236fca;
						}
						&:hover {
							.icon {
								color: #236fca;
							}
						}
					}
				}
			}
		}

		.certificate-detail {
			justify-content: normal !important;
			align-items: flex-start;
			margin-bottom: 5px;
		}
	}
</style>
